import React from 'react';
import { ShieldCheck, CreditCard } from 'lucide-react';
export function StickyTopBar() {
  return;
}